// This Utility contains all data cleanup operations

export const sanitizeForm = (data) => {
    return Object.fromEntries(
        Object.entries(data).map(([key, value]) => {
            if (key.includes("date") && (value === "" || value === null)) {
                // Ensure empty or null date fields are converted to null
                return [key, null];
            }
            if (value === "" || value === null) {
                // Keep non-date fields as empty strings
                return [key, ""];
            }
            return [key, value]; // Pass valid values unchanged
        })
    );
};
